module.exports = __webpack_public_path__ + "img/10800.a14ee8af.jpg";